import clsx from "clsx";
import { useProtectedObjectUrl } from "../../hooks/useProtectedObjectUrl";

// ============================================================================
// <img> per file serviti da /uploads, protetti da autenticazione. Un tag <img>
// normale non allega il token JWT, quindi riceverebbe un 401: il file va
// scaricato via apiClient e mostrato tramite object URL.
//
// Quel lavoro sta ora in `useProtectedObjectUrl`, che tiene una cache
// condivisa per file_url: cosi' la lightbox mostra la foto gia' scaricata da
// questa miniatura invece di riscaricarla a piena risoluzione.
// ============================================================================

interface AuthedImageProps {
  src: string;
  alt: string;
  className?: string;
}

export function AuthedImage({ src, alt, className }: AuthedImageProps) {
  const { objectUrl, failed } = useProtectedObjectUrl(src);

  if (failed) {
    // File non caricabile (permesso negato o mancante): spazio vuoto, senza
    // rompere il layout della griglia di miniature.
    return <div className={className} />;
  }
  if (!objectUrl) {
    return <div className={clsx(className, "animate-pulse bg-black/10")} />;
  }
  return <img src={objectUrl} alt={alt} className={className} />;
}
